import { Injectable } from '@angular/core';
import { VideoTrackingService } from '../video-tracking/video-tracking.service';

/**
 * Session tracking for audio stimulus.
 *
 * Audio playback produces the same event and metric shapes as video — the
 * stimulus player is one HTMLMediaElement-generic component — so the tracking
 * logic is inherited wholesale and only the session labelling differs.
 *
 * It is a separate root instance rather than a shared one on purpose:
 * VideoTrackingService holds a single currentSession and pushes every
 * generateAnalytics() result onto analytics$, which AiModeratorService maps
 * straight onto videoAnalytics.aggregateMetrics. Sharing one instance would let
 * an audio clip clobber an in-flight video session and would blend audio
 * numbers into the video aggregates reported for an interview.
 */
@Injectable({
    providedIn: 'root',
})
export class AudioTrackingService extends VideoTrackingService {
    protected override sessionKind = 'audio';
}
